import { useContext } from "react";
import { DbContext } from "./context";

export const useDb = () => {
    const context = useContext(DbContext);
    if (!context) {
        throw new Error('No db context');
    }
    return context.db;
};